import { Typography } from '@mui/material';
import * as React from 'react';
import { ChannelItemListing } from '../../../../sic-lib/types/ChannelItem';
import { DebugObject } from '../../../Shared/DebugObject';

interface Props {
    channelItem: ChannelItemListing;
}

export default React.memo(function ConversationListItemListing({ channelItem }: Props) {
    return (
        <>
            <Typography variant="body1" display="block" whiteSpace="pre-wrap" p={2}>
                {channelItem.text}
            </Typography>
            <DebugObject object={channelItem} />
        </>
    );
});
